import { render, staticRenderFns } from "./CommitItem.vue?vue&type=template&id=a8b028fa&scoped=true"
import script from "./CommitItem.vue?vue&type=script&lang=js"
export * from "./CommitItem.vue?vue&type=script&lang=js"
import style0 from "./CommitItem.vue?vue&type=style&index=0&id=a8b028fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8b028fa",
  null
  
)

export default component.exports